import FormikInputField from "components/common/Fields/FormikInputField";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import ErrorBoundary from "components/ErrorBoundary";
import { Field } from "formik";
import useAxios from "hooks/useAxios";
import AccumulatorTab from "pages/Configuration/AccumulatorTab";
import Location from "pages/Configuration/Location";
import OrderingTab from "pages/Configuration/OrderingTab";
import PatientType from "pages/Configuration/PatientType";
import PayorTab from "pages/Configuration/PayorTab";
import Rule from "pages/Configuration/Rule";
import React, { useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Select from "react-select";
import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { onExport } from "utils/helper";
import { LimitedChipsContainer, Option } from "components/Options";
import useContextService from "hooks/useContextService";
import { cloneDeep } from "lodash";
import Loader from "components/Loader";
import ReactSelect from "react-select";
let RuleHardCodedata = [];
let StatusHardCodedata = [];
const AccmulatorTable = (props) => {
  const initialStates = {
    currentPage: 1,
    pageSize: 10,
    order: 'desc',
    orderBy: 'modifiedDate',
    filters: [],
  }
  const {
    states: { configAccumulatorType },
    setStates,
  } = useContextService();
  const { search } = configAccumulatorType;
  const { rowData, orgId,setCEDId, CEDid ,manvalConfig, toggleSider,
  collapseSider,selectedAccumulator,
  setSelectedAccumulator,setACCflag, ACCflag,AccumulatorTable,SetAccumulatorTable,setCElevelflag,
  configlevel,CElevelflag,setLoading,
  loading,resetFilterFlag,
                SetResetFilterFlag
} = props;

  const API = useAxios();
  const [key, setkey] = useState("accumulatorTab");
  const [reset, setReset] = useState(false);
  const [data, setData] = useState([]);
  const [AccumulatorData, SetAccumulatorData] = useState([]);
  const [SelectedAccumulator, SetSelectedAccumulator] = useState(null);
  const [selectedRule, setSelectedRule] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [accmulatorRecords, setAccmulatorReocords] = useState("");
  const [desablestatus, setdesablestatus] = useState(false);
  // const [loading, setLoading] = useState(false);

  const onKeyChange = (k) => {
    setkey(k);
    setReset(!reset);
  };
  const handleExport = async () => {
    const { access_token } =
      JSON.parse(localStorage.getItem("pharmaforce")) || {};
    const action = `${process.env.REACT_APP_ENDPOINT}/CPConfig/configuration/ConfigurationExportAll?access_token=${access_token}`;
    onExport(action, search);
  };
  useEffect(()=>{
  SetAccumulatorData([])
  SetAccumulatorTable([])

  },[orgId])
  useEffect(() => {
    if(CEDid > 0){
     handelAccumulator(search);
    } 
  }, [SelectedAccumulator,CEDid]);

  const handelAccumulator = async (filterObj) => {
    
   
    if (filterObj != undefined) {
      initialStates.filters = filterObj.filters;
      initialStates.order = filterObj.order
        ? filterObj.order
        : initialStates.order;
      initialStates.orderBy = filterObj.orderBy
        ? filterObj.orderBy
        : initialStates.orderBy;
      initialStates.currentPage = filterObj.currentPage
        ? filterObj.currentPage
        : initialStates.currentPage;
    }
    if (filterObj == undefined) {
      filterObj = initialStates
    }
    setLoading(true);
    try {
      const { data } = await API.post(
        `SBConfig/coveredentity/accumulationlist/${CEDid}`,
        filterObj,
        {
          hasDefaultURL: true,
        }
      );
      SetAccumulatorTable(data.items);
      setAccmulatorReocords(data.totalRecords);
      setLoading(false);
      //setCEDId(0);
    } catch (error) {
      setLoading(false);
    }
  };

  const handelAccmulatorSelect = async () => {

    // SetAccumulatorData([])
    setLoading(true);
    try {
      const payload = [];
      setLoading(true);
      payload.AccumulatorEntityList = rowData.coveredEntityID;
      let AccumulatorEntityList = [payload.AccumulatorEntityList];
      setLoading(true);
      const data = await API.get(

        `SBConfig/coveredentity/acclist/${AccumulatorEntityList}`,
        {
          hasDefaultURL: true,
        }
      );
      setLoading(true);
      const formattedOptions = data.data.map((item) => ({
        value: item.accumulatorID,
        label: item.ceName,
      }));

      SetAccumulatorData(formattedOptions);
      if (formattedOptions.length === 1) {
        SetSelectedAccumulator(formattedOptions[0]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    handelAccmulatorSelect();

  }, []);


  const handelAccumulatorChange = (selected) => {
    SetSelectedAccumulator(selected);
  };
  const fetchRule = async () => {
    debugger;
    try {
      const { data } = await API.get(`SBConfig/TypeStatus/ruledropdown`, { hasDefaultURL: true });
      console.log(data, "Account Type Data")
      for (var x in data) {
        RuleHardCodedata.push({ "value": data[x].id, "label": data[x].description })
      }
      console.log(RuleHardCodedata, "RuleHardCodedata Type Data")
    }

    catch (err) {

    }
  }
  useEffect(() => {
    RuleHardCodedata = [];
    StatusHardCodedata = [];
    fetchRule();
    fetchStatus();
  }, [])
  const fetchStatus = async () => {
    try {
      const { data } = await API.get(`SBConfig/TypeStatus/ruleStatusdropdown`, { hasDefaultURL: true });
      console.log(data, "Account Type Data")
      for (var x in data) {
        StatusHardCodedata.push({ "value": data[x].id, "label": data[x].description })
      }
      console.log(StatusHardCodedata, "StatusHardCodedata Type Data")
    }

    catch (err) {

    }
  }


  const handelRuleChange = async (selectedOption) => {
    setSelectedRule(selectedOption);
  };

  const handelStatusChange = async (selected) => {
    setSelectedStatus(selected);
  };

  // useEffect(() => {
  //   handelAccmulatorSelect();
  // }, [SelectedAccumulator]);


  const handleSearchColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(search);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
    }
    await handelAccumulator(filterObj);
  };
  const handlePageChange = (filter, haveColFilter) => {
    const filterObj = cloneDeep(initialStates);

    if (haveColFilter) {
      //   filterObj.filters = [...filterObj.filters, ...filter.filters];
      filterObj.currentPage = filter.currentPage;
      filterObj.pageSize = filter.pageSize;
      filterObj.orderBy = filter.orderBy;
      filterObj.order = filter.order;

      handelAccumulator(filterObj);
    } else {
      filterObj.orderBy = filter.orderBy;
      filterObj.order = filter.order;

      handelAccumulator(filterObj);
    }
  };
  const handleResetRule = () => {
    debugger
    setSelectedRule("");
    setSelectedStatus("");
    setdesablestatus(false);
  }

  const handledesablestatus = () => {
     debugger
    // if (desablestatus) {
    //   setdesablestatus(false);
    // } else {
    //   setdesablestatus(true);
    // }
    setdesablestatus(true);
  }

  return (
    <div>
      <div className="">
      
          {/* {loading && <Loader opacity={0.02} color="black" />} */}
            <AccumulatorTab
              AccumulatorTable={AccumulatorTable}
              rowData={rowData}
              accmulatorRecords={accmulatorRecords}
              handelAccumulator={handelAccumulator}
              handelSort={handlePageChange}
              filter={search}
              CEDid={CEDid}
              onSearchColumnFilter={handleSearchColumnFilters}
              manvalConfig={manvalConfig}
              toggleSider={toggleSider}
                  collapseSider={collapseSider}
                  selectedAccumulator={selectedAccumulator}
                  setSelectedAccumulator={setSelectedAccumulator}
                  setACCflag={setACCflag} ACCflag={ACCflag}
                  setCElevelflag={setCElevelflag}
                  configlevel={true}
           CElevelflag={CElevelflag}
           resetFilterFlag = {resetFilterFlag}
                SetResetFilterFlag= {SetResetFilterFlag}
            />
         
      </div>
     
    </div>
  );
};

export default AccmulatorTable;
